// utils/specUtils.ts
export const convertSpecsToObject = (specs: any[] | Record<string, any> | null | undefined): Record<string, any> => {
    const specsObject: Record<string, any> = {};
    
    if (!specs) return specsObject;
    
    if (Array.isArray(specs)) {
        specs.forEach(spec => {
            try {
                specsObject[spec.key] = JSON.parse(spec.value);
            } catch {
                specsObject[spec.key] = spec.value;
            }
        });
    } else {
        Object.assign(specsObject, specs);
    }
    
    return specsObject;
};

export const convertSpecsToArray = (specs: Record<string, any> | null | undefined): Array<{id: string, key: string, value: string}> => {
    if (!specs || typeof specs !== 'object' || Array.isArray(specs)) {
        return [];
    }
    
    return Object.entries(specs).map(([key, value]) => ({
        id: `spec-${Date.now()}-${Math.random()}`,
        key: key,
        value: typeof value === 'string' ? value : JSON.stringify(value)
    }));
};